class PairWith extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.trigger?.element) return

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const currentState = this.getAttribute('aria-expanded') === 'true'

    if (this.getAttribute('aria-expanded') === 'true') {
      this.els.text.element.innerHTML =
        this.els.trigger.element.dataset.showMore
    } else {
      this.els.text.element.innerHTML =
        this.els.trigger.element.dataset.showLess
    }

    this.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('pair-with')) {
  customElements.define('pair-with', PairWith)
}
